module.exports = __webpack_public_path__ + "img/album11_04.a4e49391.jpg";